import { getLocale } from "../runtime";

const sv_campaigndaysleft = /** @type {(inputs: {days: NonNullable<unknown>}) => string} */ (inputs) => {
	return `Erbjudandet gäller i ${inputs.days} dagar till`
};

const campaigndaysleft = /** @type {(inputs: {days: NonNullable<unknown>}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_campaigndaysleft(inputs)
	return "campaignDaysLeft";
};

export { campaigndaysleft as "campaignDaysLeft" };